<!--
 * @Descripttion: 
 * @version: 
 * @Author: CoderXZ
 * @Date: 2020-06-30 19:34:49
 * @LastEditors: CoderXZ
 * @LastEditTime: 2020-08-13 18:45:53
-->
<template>
  <div class="mod">
    <!--头部轮播图-->
    <div class="box-other">
      <img-swiper-block></img-swiper-block>
    </div>

    <!-- <special-course></special-course> -->
    <div class="box">
      <!-- <img
              class="avator"
              src="./images/img_32389_0_253.png"
      />
      <img
              class="user"
              src="./images/img_32389_0_307.png"
      />-->

      <!-- 推荐课程-->
      <!-- <recommend-course></recommend-course> -->
      <!-- <Orient></Orient> -->
      <!-- <first-title message="推荐书籍" type="1"></first-title> -->
      <!-- <recommend></recommend> -->
      <floor-class-book></floor-class-book>
      <!--楼层数据-->
      <!-- <floor-data></floor-data> -->
      <!--名师专区-->
      <!-- <first-title message="推荐课程" type="2"></first-title> -->
      <floor-class-course></floor-class-course>
      <!-- <teacher-block></teacher-block> -->
    </div>
  </div>
</template>
<script>
import RecommendCourse from "./components/recommendCourse";
import FloorData from "./components/floorData";
import TeacherBlock from "./components/teacherBlock";
import ImgSwiperBlock from "./components/ImgSwiperBlock";
import SpecialCourse from "./components/specialCourse";

import Recommend from "./components/recommend";
import FirstTitle from "./components/firstTitle";
import FloorClassBook from "./components/floorClassBook";
import FloorClassCourse from "./components/floorClassCourse";
import Orient from "./components/orient";

export default {
  components: {
    SpecialCourse,
    ImgSwiperBlock,
    TeacherBlock,
    FloorData,
    RecommendCourse,
    Recommend,
    FirstTitle,
    FloorClassBook,
    FloorClassCourse,
    Orient
  },
  data() {
    return {};
  }
};
</script>
<style src="./index.css" scoped >
</style>
<style scoped lang="less">
/deep/ .el-card {
  border: none !important;
}
.box-other {
  width: 1210px;
  margin: 10px auto;
}
</style>

<style>
.el-menu--popup-right-start {
  background-color: white !important;
  width: 600px;
  height: 430px;
}
.el-menu--vertical {
  position: absolute !important;
  top: 114px !important;
  z-index: 2041;
}
</style>
